import * as React from 'react';
import { getSEPorts } from 'src/api/shipmentExecution';
import { useFieldProps } from 'src/hooks/form/useField';
import { useSelect, useStaticSelect } from 'src/hooks/form/useSelect';
import useApi from '../useApi';

const useSEPorts = (props: useFieldProps<{ shipmentExecutionId: string; fieldId: string }>) => {
  const { shipmentExecutionId: id, fieldId } = props.extraData || {};
  const ports = useApi(getSEPorts);
  const field = useSelect(
    props,
    getSEPorts,
    (data) => data?.map(dataMap) || [],
    (queryString) => ({ queryString, id, fieldId })
  );

  React.useEffect(() => {
    if (ports.status === 'FINISHED') {
      field.setOptions(ports.data?.map(dataMap) || []);
    }
  }, [ports.status]);

  React.useEffect(() => {
    if (field.value) ports.call({ queryString: field.value, id, fieldId });
  }, [field.value]);

  const dataMap = (item) => ({
    key: item.code,
    label: item.name,
    ...item,
  });

  return field;
};

export default useSEPorts;
